var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "signup default-content" }, [
    _c("div", { staticClass: "signup__container" }, [
      _c("div", { staticClass: "signup__column signup__info" }, [
        _c("h2", { staticClass: "section-title" }, [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _c("p", { staticClass: "signup__text" }, [_vm._v(_vm._s(_vm.content))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "signup__column" }, [
        _c(
          "form",
          {
            staticClass: "signup__form",
            attrs: { id: "newsletterForm", "data-vv-scope": "newsletterForm" }
          },
          [
            _c("theme-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|email",
                  expression: "`required|email`"
                }
              ],
              attrs: {
                "show-label": false,
                name: "email",
                placeholder: "Enter your email",
                value: _vm.email,
                "valid-scope": "newsletterForm"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "signup__button" }, [
              _c(
                "button",
                {
                  staticClass:
                    "theme-btn theme-btn--theme theme-btn--block whitespace-nowrap",
                  attrs: { type: "submit", id: "newsletterSubmit" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.signup.apply(null, arguments)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.locales &&
                          _vm.locales.common &&
                          _vm.locales.common.signup
                      ) +
                      "\n          "
                  )
                ]
              )
            ])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c0ed343", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c0ed343","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Signup.vue
// module id = 588
// module chunks = 1